import { $businessUnit, $tenant, getTag, useUrlContext } from '@msdk/common'
import { Entity } from '@msdk/definitions'
import { ButtonPrimary, COLORS, createComponentWrapperWithRef, Menu, MenuItem, styled } from '@msdk/ui'
import { KeyboardArrowDownOutlined } from '@mui/icons-material'
import { Typography } from '@mui/material'
// import { styled } from '@msdk/ui'
import { MouseEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { useBusinessUnitList } from 'state/business-unit/hooks'

const MuiAvatarInfo = styled(ButtonPrimary)`
  display: flex;
  border-radius: 8px;
  padding: 16px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  background-color: transparent;
  height: unset;
  margin-top: 4px;
  margin-bottom: 4px;

  &:hover {
    background-color: ${COLORS.blue900};
    box-shadow: unset;
  }
`

const NovaAvatarInfo = styled(ButtonPrimary)`
  display: flex;
  border-radius: 8px;
  padding: 16px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  background-color: transparent;
  height: unset;
  margin-top: 4px;
  margin-bottom: 4px;

  &:hover {
    background-color: transparent;
    color: white;
    box-shadow: unset;
  }
`

export const AvatarInfo = createComponentWrapperWithRef(
  {
    mui: MuiAvatarInfo,
    nova: NovaAvatarInfo,
  },
  'AvatarInfo',
)

export function ClinicMenu() {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)
  const [open, setOpen] = useState<boolean>(false)
  const buList = useBusinessUnitList()
  const currentBuId = useRecoilValue($businessUnit)
  const currentBu = buList.find((b) => b.id === currentBuId) as Entity
  const otherBus = buList.filter((b) => b.id !== currentBuId)
  const navigate = useNavigate()
  const tenant = useRecoilValue($tenant)
  const url = useUrlContext()
  const { sitemap } = url.context
  const [buToReach, setBuToReach] = useState('')

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    if (otherBus.length > 0) {
      setAnchor(event.currentTarget)
      setOpen(() => true)
    }
  }

  const handleClose = () => {
    setAnchor(null)
    setOpen(() => false)
  }

  const onBuSelection = async (buId: string) => {
    setBuToReach(buId)
    setOpen(false)
  }

  return (
    <>
      <AvatarInfo onClick={handleClick} data-test-id={getTag('shell', 'header', 'avatar', 'button')}>
        <Typography>{`${currentBu.fields['NAME']?.toStringForView()}`}</Typography>
        {otherBus.length > 0 && <KeyboardArrowDownOutlined />}
      </AvatarInfo>
      <Menu
        anchorEl={anchor}
        open={open}
        onClose={handleClose}
        TransitionProps={{
          onExited: () => {
            if (buToReach) {
              navigate(`/${tenant}/${sitemap}/switch-to-clinic/${buToReach}`)
            }
          },
        }}
      >
        {otherBus.map((bu) => (
          <MenuItem key={bu.id} onClick={() => onBuSelection(bu.id)}>
            <Typography>{`${bu.fields['NAME']?.toStringForView()}`}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
